import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import { loadRequest, loadSuccess, loadFailure } from './actions';

export function* loadCriaAgendamento({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}criaAgendamento&pagina&token=${state.auth.token}`,
      {
        agendamento: {
          codCdd: payload.codCdd,
          codEmp: payload.codEmp,
          codCliente: payload.codCliente,
          codMotorista: payload.codMotorista,
          ordemCarga: payload.ordemCarga,
          codTipoCarroceria: payload.codTipoCarroceria,
          codTransportadora: payload.codTransportadora,
          codVeiculo: payload.codVeiculo,
          dhAgendamento: payload.dhAgendamento,
          assoalho: payload.assoalho,
        },
      }
    );
    yield put(loadSuccess(response.data));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar ao criar um novo agendamento, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
